// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { ForgotPasswordScreen } from '../features/auth/ForgotPasswordScreen'
import { text } from '../shared/routing/search'

export const Route = createFileRoute('/forgot')({
  staticData: { screenId: 'AuthForgotPasswordScreen', access: 'signed out' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { email?: string } => ({
    email: text(search.email),
  }),
  component: AuthForgotPasswordScreen,
})

function AuthForgotPasswordScreen() {
  const { email } = Route.useSearch()
  return <ForgotPasswordScreen email={email} />
}
